<div class="mt-3" *ngFor="let pdf of document?.pdfs">
    <div [innerHTML]="pdf?.html | safeHtml" ></div>
</div>